export class ScribanFunctionDescription {
    name = "";
    ParamString = "";
}
